import { FETCH_SITE_PROPERTIES_SUCCESS } from './site-properties-types';

type State = Record<string, any>;

export default function siteProperties(state: State = {}, { type, payload }: any): State {
  switch (type) {
    case FETCH_SITE_PROPERTIES_SUCCESS:
      return payload;
    default:
      return state;
  }
}
